import React, {useCallback, useState} from 'react'
import {EntitySelectorMenu} from "./menu/menu"
import EntitySelectorMain from "./main/selector-main"
import {MentionOption} from "../editor/plugins/mentions/option"

export const ENTITY_SELECTOR_MENU_HEIGHT   = 50
export const ENTITY_SELECTOR_SEARCH_HEIGHT = 54

export enum EntitySelectorEntityType {
    USER        = 'recent',
    TASK        = 'browse',
    DOCUMENT    = 'document',
    PROJECT     = 'project',
}

export enum EntitySelectorListType {
    RECENT  = 'recent',
    BROWSE  = 'browse'
}

const menuItems = [
    {id: EntitySelectorEntityType.USER,     label: 'User'},
    {id: EntitySelectorEntityType.TASK,     label: 'Task'},
    {id: EntitySelectorEntityType.DOCUMENT, label: 'Document'},
    {id: EntitySelectorEntityType.PROJECT,  label: 'Project'},
]

type Props = {
    userMentions        : MentionOption[]
    projectId?          : ID
    initialEntityType?  : EntitySelectorEntityType
    onEntitySelected    : {(entity:MentionOption):void}
}

const debug = false
// const debug = "EntitySelector"

export default function EntitySelector (props:Props) {

    const [entityType, setEntityType]   = useState(props.initialEntityType ? props.initialEntityType : EntitySelectorEntityType.USER)

    const onChangeMenu = useCallback((menuId:EntitySelectorEntityType)=>{
        setEntityType(menuId)
    }, [])

    const onTab = () => {
        const index = _.findIndex(menuItems, item=>item.id === entityType)
        const nextMenuItem = menuItems[index + 1]

        if (nextMenuItem)   onChangeMenu(nextMenuItem.id)
        else                onChangeMenu(menuItems[0].id)
    }

    const onEntitySelected = useCallback((entity:MentionOption)=>{
        debug && console.log(debug, 'onEntitySelected', entity)
        props.onEntitySelected(entity)
    }, [])

    debug && console.log(debug, 'render', entityType)

    const styles = {
        width   : 450,
        height  : 350
    }

    return (
        <div className="gd-entity-selector" style={styles}>
            <EntitySelectorMenu menuItems           = {menuItems}
                                currentEntityType   = {entityType}
                                onSelect            = {onChangeMenu}/>

            <EntitySelectorMain currentEntityType   = {entityType}
                                userMentions        = {props.userMentions}
                                projectId           = {props.projectId}
                                onEntitySelected    = {onEntitySelected}
                                onTab               = {onTab}/>
        </div>
    )
}
